import { z } from "zod";
import { PROJECT_LIST } from "./consts";
export const schema = z.object({
    [PROJECT_LIST]: z.string().min(1, "This field is required"),
});
export type formValues = z.infer<typeof schema>;
